import { BeneficiaryDto } from "api/risk";
import { useAsyncResource } from "back-office/shared/hooks/useAsyncResource";
import { useCallback, useMemo } from "react";
import { risksAPI } from "services/swagger-api/riskApi";

export interface RiskBeneficiaries {
  /** Beneficiaries of the file, in their order; empty while loading, on failure or when there are none. */
  beneficiaries: BeneficiaryDto[];
  isLoading: boolean;
}

/**
 * Beneficiaries of a file (the manager on a legal protection file "for the manager").
 * Without a file, nothing is loaded.
 */
export const useRiskBeneficiaries = (riskId?: string): RiskBeneficiaries => {
  const fetchBeneficiaries = useCallback(
    () => risksAPI.getBeneficiaires({ risqueAssureId: riskId! }),
    [riskId]
  );

  const { data, isLoading } = useAsyncResource(fetchBeneficiaries, Boolean(riskId));

  return useMemo(() => ({
    beneficiaries: [...(data?.items ?? [])].sort((a, b) => a.order - b.order),
    isLoading
  }), [data, isLoading]);
};
